import { type DayLabel, describeDay, formatTime } from '../../lib/format';

type Translate = (key: string) => string;

/** A day label as words: the locale's "Today" and "Yesterday", or the formatter's date. */
export function dayText(day: DayLabel, t: Translate): string {
  if (day.kind === 'today') return t('chat.today');
  if (day.kind === 'yesterday') return t('chat.yesterday');
  return day.label;
}

/**
 * The inbox row's right-hand time: the clock for today, otherwise the same day label the
 * thread's separators use (D4). One rule, both consumers — `describeDay` decides the day
 * here exactly as it does above a bubble.
 */
export function listTime(iso: string | null, now: Date, t: Translate): string {
  if (!iso) return '';
  const day = describeDay(iso, now);
  return day.kind === 'today' ? formatTime(iso) : dayText(day, t);
}
